module.exports = __webpack_public_path__ + "img/carrier-x4-7500-thumb.68384073.jpg";